// Desktop left menu, grouped: Daily · Business · Catalogue · System (owner spec
// 2026-10-01). Entries follow the route guards (lib/appShell/navModel.ts).
import { cn } from '@/lib/utils';
import { useT } from '@/lib/i18n';
import { activeNavPath, desktopGroups, ADMIN_NAV, type Access } from '@/lib/appShell/navModel';
import { NavIcon } from './navIcons';
import { ShellLink } from './ShellLink';

export function DesktopNav({ access, pathname }: { access: Access; pathname: string }) {
  const { t } = useT();
  const active = activeNavPath(pathname, ADMIN_NAV);
  return (
    <nav aria-label={t('Menu')} className="flex-1 px-3 py-3 overflow-y-auto">
      {desktopGroups(access).map((g, gi) => (
        <div key={g.group} className={cn(gi > 0 && 'mt-4')}>
          <p
            id={`nav-g-${g.group}`}
            data-nav-group-label
            className="px-3 pb-1 text-[11.5px] font-semibold text-gray-400"
          >
            {t(g.label)}
          </p>
          <ul aria-labelledby={`nav-g-${g.group}`} className="space-y-0.5">
            {g.items.map((item) => {
              const on = active === item.to;
              return (
                <li key={item.to}>
                  <ShellLink
                    to={item.to}
                    data-nav-item
                    aria-current={on ? 'page' : undefined}
                    className={cn(
                      'group flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition-colors duration-150 relative',
                      'focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C9A24A]/60',
                      on ? 'text-adm-gold-ink' : 'text-gray-600 hover:text-gray-900 hover:bg-[#FAF6EC] dark:hover:bg-adm-surface-2',
                    )}
                    style={on ? { background: 'linear-gradient(135deg, rgba(201, 162, 74, 0.14), rgba(201, 162, 74, 0.06))' } : undefined}
                  >
                    {on && <span aria-hidden className="absolute left-0 top-2 bottom-2 w-[3px] rounded-r-full" style={{ background: '#C9A24A' }} />}
                    <span aria-hidden className={cn('transition-colors', on ? 'text-[#C9A24A]' : 'text-gray-400 group-hover:text-[#C9A24A]')}>
                      <NavIcon to={item.to} />
                    </span>
                    <span className="flex-1 truncate">{t(item.label)}</span>
                  </ShellLink>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}
